import { defineChain } from 'viem'

export default defineChain({
	id: 88888,
	name: 'Chiliz Chain',
	network: 'chiliz-chain',
	rpcUrls: {
		default: {
			http: ['https://rpc.chiliz.com', 'https://rpc.ankr.com/chiliz']
		}
	},
	blockExplorers: {
		default: {
			name: 'Chiliz Explorer',
			url: 'https://chiliscan.com/'
		}
	},
	nativeCurrency: {
		name: 'Chiliz',
		symbol: 'CHZ',
		decimals: 18
	},
	testnet: false,
	maxSupply: 8888888888000000
})
